import { render, staticRenderFns } from "./WalletId.vue?vue&type=template&id=42425fc4&scoped=true"
import script from "./WalletId.vue?vue&type=script&lang=js"
export * from "./WalletId.vue?vue&type=script&lang=js"
import style0 from "./WalletId.vue?vue&type=style&index=0&id=42425fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42425fc4",
  null
  
)

export default component.exports